console.log('Hello from rl-contact-form-submission.js');
document.addEventListener("DOMContentLoaded", () => {
    const form = document.querySelector('#contact_form');
    if (!form) return;
    const submit_btn = form.querySelector('[submit-form]');
    const errorMessage = form.querySelector('[error-message]');
    // const formSuccessMessage = document.querySelector('[form-success-message]');
    const formErrorMessage = form.querySelector('[form-error-message]');
    const inputs = form.querySelectorAll('input,textarea');

    // Prevent default form submission
    if (submit_btn) {
        submit_btn.addEventListener('click', (e) => {

            const sf_form_type = form.querySelector('.enquiry-form-inputs.active').getAttribute('data-sf-type');

            let valid = true;

            inputs.forEach(input => {
                // remove bordfer on input change
                input.addEventListener('input', () => {
                    input.style.border = 'none';
                    errorMessage.style.display = 'none';
                });
                // check if required fields are empty
                if (input.hasAttribute('required') && !input.disabled && input.value === '') {
                    input.style.border = '1px solid red';
                    input.placeholder = 'This field is required';
                    errorMessage.style.display = 'block';
                    valid = false;
                    return;
                }
                // check if required fields are empty and not disabled

            });

            if (!valid) return;

            submit_btn.classList.add('loading');
            //formSuccessMessage.classList.remove('show');
            //formErrorMessage.classList.remove('show');

            const formData = new FormData(form);

            // Convert FormData to a JavaScript object
            const formObject = Object.fromEntries(formData.entries());

            // get selected order items and messages
            let orderItemsMessagesArray =[];
            const orderItemsElements = form.querySelectorAll('.line-items-list input[type="checkbox"]:checked[value]');
            let orderItems = [];

            if (orderItemsElements.length > 0) {
                //creat an array of input values
                const orderItemsArray = Array.from(orderItemsElements, element => {
                    return element.value;
                });

                const orderItemsMessagesElements = form.querySelectorAll('.returns-inputs textarea');
                //creat an array of input values
                const orderItemsMessagesArray = Array.from(orderItemsMessagesElements, element => {
                    return element.value;
                });

                // create an object with order items and messages
                orderItemsArray.forEach((item, index) => {
                    console.log("Item", item);
                    // create object
                    orderItems.push({
                    "variantId": item,
                    "message": orderItemsMessagesArray[index]});
                });
            }

            console.log("Order Items Object", orderItems);

            // get current page URL
            const pageUrl = window.location.href;

            // Get cusotmer id

            let customerId = "";

            if (window.QF.customer) {
                customerId = window.QF.customer.id;
            }

            // If site address is yes convert to boolean
            if (formObject.site_address === 'yes') {
                formObject.site_address = true;
            } else {
                formObject.site_address = false;
            }

            // create a new instance of the Gadget client at the `api` global connected to the Development environment
            window.api = new Gadget();

            async function fetchData() {
                try {
                    let formFields = {
                        "formType": { "_link": sf_form_type },
                            "email": formObject['contact[email]'],
                            "fieldValues": {
                                "name": formObject['contact[full_name]'],
                                "telephone": formObject['contact[phone]'],
                                "email": formObject['contact[email]'],
                                "orderNumber": formObject['contact[order_id]'],
                                "message": formObject['contact[message]'],
                                "acceptsDataPrivacyTerms": true,
                            },
                            "shopifyCustomer": { "_link": customerId },
                            "page": pageUrl
                        }

                    if (sf_form_type == 6) {
                        formFields = {
                            "formType": { "_link": sf_form_type },
                            "email": formObject['contact[email]'],
                            "fieldValues": {
                                "name": formObject['contact[full_name]'],
                                "telephone": formObject['contact[phone]'],
                                "email": formObject['contact[email]'],
                                "orderNumber": formObject['contact[order_id]'],
                                "message": formObject['contact[message]'],
                                "acceptsDataPrivacyTerms": true,
                                "orderLineItems": orderItems,
                            },
                            "shopifyCustomer": { "_link": customerId },
                            "page": pageUrl
                        }
                    }
                    const formSubmissionRecord = await api.formSubmission.create(formFields);


                    if (formSubmissionRecord) {
                        console.log("Form Submission Record", formSubmissionRecord);
                        //formSuccessMessage.classList.add('show');
                        form.submit();
                        submit_btn.classList.remove('loading');
                    }
                } catch (error) {
                    // Catch and handle any errors
                    console.error("An error occurred:", error);
                    formErrorMessage.classList.add('show');
                    submit_btn.classList.remove('loading');
                }
            }

            fetchData();
        });
    }
});